import {useNavigate} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {useParams} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import Select from 'react-select';
import {useFormik} from 'formik';
import makeAnimated from 'react-select/animated';
import {ContentHeader, Loader} from '@components';
import {updateClient, getClientById} from '../../services/client';
import {getAllProjectNames} from '../../services/project';
import handleStatus from '../../utils/ajax';
import {logoutUser} from '@app/store/reducers/auth';

const UpdateClient = () => {
  const animatedComponents = makeAnimated();

  const [selectedProject, setSelectedProject] = useState([]);
  const [projects, setProjects] = React.useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [clientDetails, setClientDetails] = useState({});
  const [allProject, setAllProject] = React.useState([]);
  const [styleForValidaiton] = React.useState({color: 'red'});
  const array = [{value: 'Red', label: 'Red'}];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const {id} = params;
  localStorage.setItem('clientId', id);
  const getDetailsOfClient = async () => {
    setShowLoader(true);
    const res = await getClientById();
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);
    if (res.status === 200) {
      setClientDetails(res.data.data);
      setSelectedProject(
        res.data.data.project.map((project) => {
          return {value: project._id, label: project.projectName};
        })
      );
    }
    setShowLoader(false);
  };

  const validate = (values: any) => {
    let errors = {};
    if (!values.clientName) {
      errors.clientName = 'Please enter client name';
    }

    if (!values.email) {
      errors.email = 'Please enter client email';
    }

    if (!values.place) {
      errors.place = 'Please enter client place';
    }

    if (!values.place) {
      errors.place = 'Please enter client place';
    }

    // if (!values.status) {
    //   errors.status = 'Please select client status';
    // }

    return errors;
  };

  const onSubmit = async (values: any) => {
    try {
      const payload = {
        clientName: values.clientName,
        email: values.email,
        project: selectedProject.map((val: any) => {
          return val.value;
        }),
        additionalInformation: values.additionalInformation,
        status: values.status
      };
      const resp = await updateClient(payload);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

      if (resp.status === 200) {
        if (resp?.data?.ok) {
          toast.success(resp?.data?.message || 'Client Updated successfully');
          navigate('/all-clients');
        }
      }

      if (!resp?.data?.ok) {
        toast.error(resp?.data?.error || 'Error while updating client');
      }
    } catch (error) {
      console.error('Error while updating client:', error);
      toast.error('Error while updating client');
    }
  };

  const initialValues = {
    clientName: clientDetails.clientName,
    email: clientDetails.email,
    place: clientDetails.place,
    project: [],
    status: clientDetails.status,
    additionalInformation: clientDetails.additionalInformation
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit,
    validate
  });

  const getAllProjectNamesFn = async () => {
    const res = await getAllProjectNames();
    handleStatus(res.status);
    if (res.data.ok) {
      setAllProject(
        res.data.data.map((project: any) => ({
          value: project._id,
          label: project.projectName
        }))
      );
    }
  };

  useEffect(() => {
    getAllProjectNamesFn();
    getDetailsOfClient();
  }, []);

  if (showLoader) {
    return <Loader title={'Daily'} />;
  }

  return (
    <React.Fragment>
      <ContentHeader title="Update Client" path="/all-clients" />
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="card card-outline card-info">
              <div className="card-header">
                <h3 className="card-title">Client Information</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-10">
                    <div className="card card-primary">
                      <form onSubmit={formik.handleSubmit}>
                        <div className="card-body">
                          <div className="form-group row">
                            <label
                              htmlFor="inputName"
                              className="col-sm-2 col-form-label"
                            >
                              {' '}
                              Client Name
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="inputName"
                                placeholder="Name"
                                name="clientName"
                                onChange={formik.handleChange}
                                value={formik.values.clientName}
                              />
                              {formik.touched.clientName &&
                              formik.errors.clientName ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.clientName}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail"
                              className="col-sm-2 col-form-label"
                            >
                              Email
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="email"
                                className="form-control"
                                id="inputEmail"
                                placeholder="Email"
                                name="email"
                                onChange={formik.handleChange}
                                value={formik.values.email}
                              />
                              {formik.touched.email && formik.errors.email ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.email}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputPlace"
                              className="col-sm-2 col-form-label"
                            >
                              Place
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="inputPlace"
                                placeholder="Place"
                                name="place"
                                onChange={formik.handleChange}
                                value={formik.values.place}
                              />
                              {formik.touched.place && formik.errors.place ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.place}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputPlace"
                              className="col-sm-2 col-form-label"
                            >
                              Project
                            </label>
                            <div className="col-sm-10">
                              <Select
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={[]}
                                isMulti
                                value={selectedProject}
                                onChange={(e) => setSelectedProject(e)}
                                options={allProject}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputPlace"
                              className="col-sm-2 col-form-label"
                            >
                              Status
                            </label>
                            <div className="col-sm-10">
                              <select
                                className="form-control"
                                name="status"
                                onChange={formik.handleChange}
                                value={formik.values.status}
                              >
                                <option value="">Select</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                              {formik.touched.status && formik.errors.status ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.status}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputSkills"
                              className="col-sm-2 col-form-label"
                            >
                              Additional Information
                            </label>
                            <div className="col-sm-10">
                              <textarea
                                className="form-control"
                                id="inputSkills"
                                placeholder="Information"
                                style={{height: '120px'}}
                                name="additionalInformation"
                                onChange={formik.handleChange}
                                value={formik.values.additionalInformation}
                              ></textarea>
                            </div>
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary offset-md-2"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default UpdateClient;
